import 'vue-awesome/icons/arrow-left';

import ComponentsDisplay from '@/components/components-display/components-display.vue';
import CreateApp from '@/components/create-app/create-app.vue';

export default {
  name: 'AppManage',

  props: {
    appName: {
      type: String,
      required: true,
    },
  },

  components: {
    ComponentsDisplay,
    CreateApp,
  },

};
